import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';
import { Cycle } from '../../store/models/cycles';
import { ScreenCycle } from '../../store/models/screens';

type SearchProps = {
  onSearch: (query: string) => void;
  cycles?: Cycle[];
  screenCycles?: ScreenCycle[];
};

const Search = ({ onSearch }: SearchProps) => {
  const { t } = useTranslation();

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase();
    onSearch(query);
  };

  return (
    <div className="w-full mb-4">
      <input
        type="text"
        placeholder={t('labels.cycle.searchPlaceholder')}
        onChange={handleSearch}
        className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
      />
    </div>
  );
};

export default Search;